var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Universal/Monochrome/64x64/img.notes.64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.5 8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.82 0h21.36c4.458 0 6.075.464 7.704 1.336a9.086 9.086 0 013.78 3.78C46.536 6.746 47 8.362 47 12.819v21.362c0 4.457-.464 6.074-1.336 7.703a9.086 9.086 0 01-3.78 3.78c-1.63.872-3.246 1.336-7.703 1.336H12.819c-4.457 0-6.074-.464-7.703-1.336a9.086 9.086 0 01-3.78-3.78C.464 40.254 0 38.638 0 34.181V12.819c0-4.457.464-6.074 1.336-7.703a9.086 9.086 0 013.78-3.78C6.746.464 8.362 0 12.819 0z",
    id: "Rectangle",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fill: "currentColor",
    d: "M0 12.5h47v3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14v9.5H47v3H13.5v8H47v3H13.5V47h-3v-9.5H0v-3h10.5v-8H0v-3h10.5V14h3z",
    id: "Combined-Shape",
    fill: "currentColor",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0h27.8A9.6 9.6 0 0147 9.6V14H0V9.6A9.6 9.6 0 019.6 0z",
    id: "Rectangle",
    fill: "currentColor",
    opacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes64);
export default __webpack_public_path__ + "static/media/notes.64.445cf4fa.svg";
export { ForwardRef as ReactComponent };